// extracted by mini-css-extract-plugin
export default {"button":"UWXuv","expand":"HiIty","suffixIcon":"LXTCO","colorFromFullButton":"ipdvk","colorFromHollowButton":"-OkBJ"};